
export default {
  name: "nav",
  props: {
    dataArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      icon: require('@/static/images/047.png'),
    }
  },
  methods: {
    routerLink(path) {
      this.$emit('routerLink', path)
      this.$router.push({
        path: (this.$i18n.locale == 'en' ? '/en' : '') + path
      })
    },
    readMore(item) {
      this.$emit('routerLink', item.path)
      if (!item || !item.path) {
        return
      }
      this.$router.push({
        path: (this.$i18n.locale == 'en' ? '/en' : '') + item.path
      })
    }
  }
}
